import { fetchItemsDetails, getActivity, getTaskDetails } from './actions'
import { activityStreamState } from './state'
import {
  errorUpdater,
  loadingUpdater,
  pollingIterationUpdater,
} from './updaters'

export const fetchResultsCallback =
  ({ set }) =>
  async (idRecipient, channel, pageNumber, pageSize, activityEventTypes) => {
    const key = { idRecipient, channel }

    set(activityStreamState(key), loadingUpdater)
    try {
      const { IdTask, Events } = await getActivity(
        idRecipient,
        channel,
        pageNumber,
        pageSize,
        activityEventTypes,
      )

      if (IdTask > 0) {
        set(activityStreamState(key), (prev) => ({
          ...prev,
          idTask: IdTask,
          pageNumber,
          pageSize,
          activityEventTypes,
          pollingIteration: 1,
        }))
      } else {
        const items = await fetchItemsDetails(Events.Items, channel)

        set(activityStreamState(key), {
          idTask: IdTask,
          pollingIteration: 0,
          items,
          pageNumber,
          pageSize,
          activityEventTypes,
          totalItems: Events.TotalItems,
          loading: false,
          error: false,
          loaded: true,
        })
      }
    } catch (error) {
      console.error('### polling error', error)
      set(activityStreamState(key), errorUpdater)
    }
  }

export const pollingCallback =
  ({ set, reset, snapshot }) =>
  async (idRecipient, channel) => {
    const key = { idRecipient, channel }
    const { idTask, pageNumber, pageSize } = await snapshot.getPromise(
      activityStreamState(key),
    )
    if (idTask) {
      try {
        const { Status, Metadata } = await getTaskDetails(idTask)
        if (Status === 'Completed') {
          const { Items, TotalItems: totalItems } = JSON.parse(Metadata)
          const items = await fetchItemsDetails(Items, channel)
          set(activityStreamState(key), {
            items,
            pageNumber,
            pageSize,
            totalItems,
            loading: false,
            error: false,
            loaded: true,
          })
        } else if (Status === 'Error' || Status === 'Aborted ') {
          set(activityStreamState(key), errorUpdater)
        } else {
          set(activityStreamState(key), pollingIterationUpdater)
        }
      } catch (error) {
        console.error('### polling error', error)
        set(activityStreamState(key), errorUpdater)
      }
    }
  }
